import React, { Component } from "react";
import Slider from "react-slick";

import  pic1 from './../../../images/main-slider/9.jpeg';
import  pic2 from './../../../images/main-slider/1.jpeg';
import  pic3 from './../../../images/main-slider/2.jpeg';
import  pic4 from './../../../images/main-slider/12.jpeg';
import  pic5 from './../../../images/main-slider/5.jpeg';
import  pic6 from './../../../images/main-slider/13.jpeg';

const galleryBlog = [
	{ image: pic1,	 },
	{ image: pic2,	 },
	{ image: pic3,	 },
	{ image: pic4,	 },
	{ image: pic5,	 },
	{ image: pic6,	 },
]


export default class SwiperSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null
    };
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    });
  }

  render() {
		var settings = {		
			arrows: false,
			centerMode: true,
			
        };
    return (
      <div>
        <style>{`
			.swiper-main-image {
				width: 100%;
				height: 500px;
				object-fit: cover;
				display: block;
			}
			.swiper-thumb-image {
				width: 100%;
				height: 120px;
				object-fit: cover;
				display: block;
				cursor: pointer;
				transition: opacity 0.3s ease;
			}
			.swiper-thumb-image:hover {
				opacity: 0.8;
			}
			@media (max-width: 768px) {
				.swiper-main-image {
					height: 400px;
				}
				.swiper-thumb-image {
					height: 80px;
				}
			}
			@media (max-width: 576px) {
				.swiper-main-image {
					height: 300px;
				}
				.swiper-thumb-image {
					height: 60px;
				}
			}
		`}</style>
       
        <Slider
          asNavFor={this.state.nav2}
          ref={slider => (this.slider1 = slider)}
		  className="owl-carousel owl-theme owl-none owl-dots-none gallery-top "
		  {...settings}
        >
			
			{galleryBlog.map((item, index) => (
				<div className="item" key={index}>
					<div className="gallery-media">
						<img src={item.image} alt="" className="swiper-main-image" />
						{/* <h4 className="title">40 X 70 East Side FF</h4> */}
					</div>
				</div>
			))}	
			
          
        </Slider>

        <Slider
          asNavFor={this.state.nav1}
          ref={slider => (this.slider2 = slider)}
          slidesToShow={5}
          swipeToSlide={true}
          focusOnSelect={true}
		  className="owl-carousel owl-theme owl-none owl-dots-none gallery-bottom container owl-btn-center-lr "
		  {...settings}
        >
			{galleryBlog.map((item, index) => (
				<div key={index}>
					<div className="item">
						<div className="gallery-box">
							<img src={item.image} alt="" className="swiper-thumb-image" />
						</div>
					</div>
				</div>
			))}
        </Slider>
      </div>
    );
  }
}

